export function arrayToThresholds(arr: string[]) {
  return arr.map((_, i, arr) => ((i + 1) * 100) / arr.length);
}
